import {
  useGetAssembliesForEvaluationQuery,
  useStructureDefectLegendsQuery,
} from '@/__generated__/graphql';
import * as state from '@/components/Analysis/state';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

export const useBulkAssemblyData = (params: { assemblyIds: string[] }) => {
  const assemblyTemplate = useAtomValue(state.assemblyTemplate);
  const setComponentDetailsById = useSetAtom(state.componentDetailsById);
  const setComponentAreasById = useSetAtom(state.componentAreasById);
  const structureId = useGetStructureId();

  const setDefectsLegends = useSetAtom(state.componentsDefectLegends);
  const setComponentsDetailsLoading = useSetAtom(state.componentsDetailsLoading);

  useStructureDefectLegendsQuery({
    variables: { structureId },
    onCompleted: (data) => {
      setDefectsLegends(data?.structure?.defectLegends || []);
    },
  });

  const { loading: assemblyDataLoading } = useGetAssembliesForEvaluationQuery({
    variables: {
      input: {
        structureId,
        templateId: assemblyTemplate?.id ?? '',
        assemblyIds: params?.assemblyIds || [],
      },
    },
    onCompleted: (data) => {
      if (data?.getAssembliesByTemplateFieldsFilters) {
        const detailsById = data?.getAssembliesByTemplateFieldsFilters.reduce((acc, assembly) => {
          acc[assembly.id] = assembly.templateFieldData;
          return acc;
        }, {} as { [key: string]: Record<string, string> });
        const areasById = data?.getAssembliesByTemplateFieldsFilters.reduce((acc, assembly) => {
          acc[assembly.id] = assembly.area ?? 0;
          return acc;
        }, {} as { [key: string]: number });
        setComponentDetailsById(detailsById);
        setComponentAreasById(areasById);
      }
    },
    skip: !assemblyTemplate,
  });

  useEffect(() => {
    setComponentsDetailsLoading(assemblyDataLoading);
  }, [assemblyDataLoading, setComponentsDetailsLoading]);
};
